import _ from 'lodash';

/**
 *
 * @param {Array} attributesAudience
 * @returns Array of object with audienceAttributeOptionsAttributes and audienceAttributeType.
 */
export const remapAudienceOptions = (attributesAudience) => {
  const audienceAttributesAttributes = _.map(attributesAudience, (audience) => {
    const { audienceAttributeType } = audience;

    const audienceAttributeOptionsAttributes = _.map(audience.audienceAttributeOptions, (option) => {
      let newOption = _.omit(option, ['__typename']);
      if (audienceAttributeType === 'job_role') {
        const jobsSelected = _.omit(newOption, ['name']);
        return { value: jobsSelected.value };
      }

      newOption = _.omit(newOption, ['id']);

      return { value: newOption.name };
    });

    return ({
      audienceAttributeOptionsAttributes,
      audienceAttributeType,
    });
  });

  return audienceAttributesAttributes;
};

/**
 *
 * @param {Array} questions
 * @returns A new screener without the '__typename';
 */
export const remapScreenerAudienceTemplate = (questions, removeId = true) => {
  const screener = _.map(questions, (question) => {
    const {
      questionOptions,
    } = question;

    let newOption = _.omit(question, ['__typename', 'questionOptions']);
    if (removeId) {
      newOption = _.omit(newOption, ['id']);
    }

    const questionOptionsAttributes = _.map(questionOptions, (questionOption) => {
      let option = _.omit(questionOption, ['__typename']);
      if (removeId) {
        option = _.omit(option, ['id']);
      }
      return option;
    });

    return ({
      ...newOption,
      questionOptionsAttributes,
    });
  });

  return screener;
};
